module.exports = __webpack_public_path__ + "static/media/portfolio 4.5c860e54.JPG";